import { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import Sidebar from '../components/AdminSidebar';
import AdminTermsModal from '../components/AdminTermsModal';
import AdminCalendar from '../components/AdminCalendar';
import CreateSessionModal from '../components/CreateSession';
import '../styles/AdminCalendar.css'; // style layoutu

export default function AdminCalendarPage() {
  const [showCreateSessionModal, setShowCreateSessionModal] = useState(false);
  const calendarRef = useRef(null);

  // NOWE: filtry – grupa i wykładowca
  const [selectedGroup, setSelectedGroup] = useState('');
  const [groups, setGroups] = useState([]);
  const [selectedLecturer, setSelectedLecturer] = useState('');
  const [lecturers, setLecturers] = useState([]);

  const handleRefresh = () => {
    if (calendarRef.current && calendarRef.current.refresh) {
      calendarRef.current.refresh();
    }
  };

  const handleSessionCreated = (success) => {
    setShowCreateSessionModal(false);
    // Refresh calendar after creating session (only if successful)
    if (success) {
      handleRefresh();
    }
  };

  // Ładowanie listy grup i wykładowców
  useEffect(() => {
    async function fetchGroups() {
      try {
        const response = await axios.get('/management/groups');
        console.log('Groups fetched:', response.data);
        setGroups(response.data || []);
      } catch (error) {
        console.error('Błąd pobierania grup:', error);
        setGroups([]);
      }
    }

    async function fetchLecturers() {
      try {
        const response = await axios.get('/management/lecturers');
        console.log('Lecturers fetched:', response.data);
        setLecturers(response.data || []);
      } catch (error) {
        console.error('Błąd pobierania wykładowców:', error);
        setLecturers([]);
      }
    }

    fetchGroups();
    fetchLecturers();
  }, []);

  return (
    <div className="admin-calendar-page">
      <AdminTermsModal />
      <Sidebar />

      <div className="main-content">
        <div className="calendar-page-inner">
          <header className="calendar-page-header">
            <div>
              <h1>Kalendarz zajęć</h1>
              <p className="calendar-page-subtitle">
                Harmonogram zajęć i wydarzeń dla wybranych grup i kursów.
              </p>
            </div>

            <div className="calendar-page-actions">
              <button className="btn-secondary" onClick={handleRefresh}>
                Odśwież
              </button>
              <button
                className="btn-primary"
                onClick={() => setShowCreateSessionModal(true)}
              >
                + Dodaj wydarzenie
              </button>
            </div>
          </header>

          {/* NOWE: filtry jak na liście kursantów – grupa + wykładowca */}
          <section className="calendar-filters-section">
            <span className="calendar-filters-label">Filtruj widok:</span>
            <div className="calendar-filters-row">
              {/* Filtr grupy */}
              <div className="calendar-select-wrap">
                <select
                  className="calendar-filter-select"
                  value={selectedGroup}
                  onChange={(e) => {
                    const value = e.target.value;
                    console.log('Group filter changed:', value);
                    setSelectedGroup(value);
                  }}
                >
                  <option value="">Wszystkie grupy</option>
                  {groups.map((group) => (
                    <option
                      key={group.group_code}
                      value={group.group_code}
                    >
                      {group.group_name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Filtr wykładowcy */}
              <div className="calendar-select-wrap">
                <select
                  className="calendar-filter-select"
                  value={selectedLecturer}
                  onChange={(e) => {
                    const value = e.target.value;
                    console.log('Lecturer filter changed:', value);
                    setSelectedLecturer(value);
                  }}
                >
                  <option value="">Wszyscy wykładowcy</option>
                  {lecturers.map((lecturer) => (
                    <option
                      key={lecturer.id || lecturer.lecturer_id}
                      value={lecturer.id || lecturer.lecturer_id}
                    >
                      {lecturer.name || `${lecturer.first_name || ''} ${lecturer.last_name || ''}`.trim() || lecturer.email}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </section>

          {/* Główna karta z kalendarzem */}
          <section className="calendar-main-section">
            {/* Backend może użyć tych propsów do filtrowania eventów */}
            <AdminCalendar
              ref={calendarRef}
              selectedGroup={selectedGroup}
              selectedLecturer={selectedLecturer}
            />
          </section>
        </div>
      </div>

      {showCreateSessionModal && (
        <CreateSessionModal onClose={handleSessionCreated} />
      )}
    </div>
  );
}
